<template>
  <div class="tab-change-pwd md:ml-4 md:mt-0 mt-4 ml-0">
    <vs-row>
      <vs-col vs-type="flex" vs-w="5">
        <connection-form :connEdit="connEdit" @cleanData="cleanData"/>
      </vs-col>
      <vs-col vs-type="flex" vs-w="7">
        <connection-list @connEdit="connEdit = $event"/>
      </vs-col>
    </vs-row>
  </div>
</template>

<script>
import ConnectionForm from "./ConnectionForm";
import ConnectionList from "./ConnectionList";

export default {
  components: {
    ConnectionForm,
    ConnectionList
  },
  data() {
    return {
      connEdit: {
        companyID: null,
        companyName: null,
        connType: null,
        created_at: null,
        database: null,
        key: null,
        name: null,
        status: null
      }
    };
  },
  methods: {
    cleanData() {
      this.connEdit = {
        companyID: null,
        companyName: null,
        connType: null,
        created_at: null,
        database: null,
        key: null,
        name: null,
        status: null
      }
    }
  },
  computed: {
    isSmallerScreen() {
      return this.$store.state.windowWidth < 768;
    }
  }
};
</script>

<style lang="scss">
#profile-tabs {
  .vs-tabs--content {
    padding: 0;
  }
}
</style>
